import React, { Component } from "react";
import completed from "../../../Assets/img/completed.png";
import starting_soon from "../../../Assets/img/starts_soon.png";
import current from "../../../Assets/img/current.png";
import ReCAPTCHA from "react-google-recaptcha";
import { authenticate, make_request, get_current_level } from "../../Utils/Utils";
const subscribe_recaptcha_ref = React.createRef();

class Edition extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      validation_error: false,
      api_response: "",
      api_error: false,
    };
  }

  resetCaptcha = () => {
    subscribe_recaptcha_ref.current.reset();  
  }

  handle_change = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  ribbonForImage() {
    if (this.props.status === "completed") {
      return <img src={completed} alt="" className="completed_rib_img" />;
    } else if (this.props.status === "ongoing") {
      return <img src={current} alt="" className="current_rib_img" />;
    } else {
      return <img src={starting_soon} alt="" className="starts_rib_img" />;
    }
  }

  onSubmit = async () => {
    if (!this.state.email) {
      this.setState({
        api_response: false,
        api_error: false,
        validation_error: "Email cannot be blank",
      });
      return;
    }
    const recaptcha_response = await subscribe_recaptcha_ref.current.executeAsync();
    if (!!recaptcha_response) {
      let responseJson = await make_request({
        path: "subscribe",
        method: "POST",
        content: "JSON",
        body: {
          email: this.state.email,
          recaptcha_response: recaptcha_response,
        },
      });
      if (responseJson && responseJson["message"])
        this.setState({
          validation_error: false,
          api_error: false,
          api_response: responseJson["message"],
        });
      else
        this.setState({
          validation_error: false,
          api_error: true,
          api_response: responseJson["error_message"],
        });
    }
  };

  playEdition = () => {
    if (authenticate()) {
      get_current_level(this.props.id);
    } else {
      window.location = '/login/'+this.props.id;
    }
  }

  actionButton() {
    if (this.props.status === "completed" || this.props.status === "ongoing") {
      return ( (this.props.rank  && this.props.rank !== "N/A") ? (
        <button onClick={this.playEdition} className="btn btn-yellow mt-1">
          RESUME PLAYING
        </button>) : (
        <button onClick={this.playEdition} className="btn btn-yellow mt-1">
          START PLAYING
        </button>)
        );
    } else {
      return (
        <React.Fragment>
          <ReCAPTCHA
            ref={subscribe_recaptcha_ref}
            size="invisible"
            sitekey={process.env.REACT_APP_GOOGLE_SITE_KEY}
            onChange={this.resetCaptcha}
          />
          <button className="btn btn-yellow mt-3" onClick={this.onSubmit}>
            SUBSCRIBE
          </button>
        </React.Fragment>
      );
    }
  }


  editionHoverArea() {
    if (this.props.status === "completed") {
      return (
        <React.Fragment>
          <p> Past Season Puzzlers </p>
          <h4> {this.props.puzzlers} </h4>
        </React.Fragment>
      );
    } else if (this.props.status === "ongoing") {
      return (
        <React.Fragment>
          <p> Your rank </p>
          <h4>
            {this.props.rank} <span> out of {this.props.puzzlers} </span>
          </h4>
        </React.Fragment>
      );
    }
  }

  editionDescriptionArea() {
    if (this.props.status === "completed" || this.props.status === "ongoing") {
      return (
        <React.Fragment>
          <div className="edition_hover_sec">
            <div className="before_hover">
              <p> {this.props.description} </p>
            </div>
            <div className="after_hover">{this.editionHoverArea()}</div>
          </div>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <p> Drop Your Email Address and we will let you know when we launch this edition.</p>
          <input
            type="email"
            className="form-control mb-2"
            placeholder="Email Address"
            name="email"
            value={this.state.email}
            onChange={this.handle_change}
          />
          <span className="wrong_txt mb-2 mt-2">
            {this.state.validation_error && <span> Enter a valid email </span>}
            {this.state.api_error && <span> {this.state.api_response} </span>}
          </span>
          <span className="success_txt mb-2 mt-2">
            {!this.state.api_error && this.state.api_response && (
              <span>Thank you for subscribing. We will keep you updated. </span>
            )}
          </span>
        </React.Fragment>
      );
    }
  }

  render() {
    return (
      <div className="col-xl-4 col-lg-6 col-md-6 col-12">
        <div className="ouredition_bg">
          {this.ribbonForImage()}
          <h5> {this.props.name} </h5>
          <img src={this.props.image} alt="" />
          {this.editionDescriptionArea()}
          <div className="text-center">
            <div className="text-center">{this.actionButton()}</div>
          </div>
        </div>
      </div>
    );
  }
}
export default Edition;
